import React, {Component} from 'react';
import {gpn} from "../GPN"
import axios from "axios";
import config from "../config";
import Back from "../sections/Back";
import Select from "../sections/MUI/Select";
import {toast} from "react-toastify";
import Modal from "../sections/MUI/Modal";
import Button from "../sections/MUI/Button";
import Field from "../sections/MUI/Field";

class EditOrder extends Component {

    state = {
        allExperts: [],

        description: "",
        payment: null,
        id: "",
        code: "",
        user: null,
        service: null,
        region: null,
        options: [],
        gadgets: [],
        time: "",
        dateTime: "",
        mDate: "",
        mTime: "",
        address: "",
        tel: "",
        expert: null,
        expers: [],
        selectExperts: [],
        status: "",
        statusPayment: "",
        price: "",

        modalExpert: false,
        modalEdit: false
    };

    componentDidMount() {
        config.scrollTop();
        this.getOrder();
        this.getExperts();
    }

    getExperts() {
        axios.get(`${config.api}/admin/experts?token=${config.token}`)
            .then(r => {
                this.setState({allExperts: r.data.result});
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    getOrder() {
        axios.get(`${config.api}/admin/order?token=${config.token}&id=${this.props.params.id}`)
            .then(r => {
                const {dateTime} = r.data.result;
                let dtArr = dateTime.split(" ");
                let mDate = dtArr[0];
                let mTime = dtArr[1];
                this.setState({
                    ...r.data.result,
                    mDate,
                    mTime
                });
            })
            .catch(err => {
                config.handleError(err);

            });
    }

    setStatus(status = "") {
        let params = new URLSearchParams();
        params.append("id", this.state.id);
        params.append("status", status);
        toast.info("در حال ثبت وضعیت ...")
        axios.put(`${config.api}/admin/order/status?token=${config.token}`, params)
            .then(r => {
                toast.success("با موفقیت ثبت شد.")
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    refExpert() {
        const {id, selectExperts} = this.state;
        let params = new URLSearchParams();
        params.append("id", id);
        params.append("experts", JSON.stringify(selectExperts));
        toast.info("در حال ثبت متخصص ...")
        this.setState({
            modalExpert: false
        });
        axios.put(`${config.api}/admin/order?token=${config.token}`, params)
            .then(r => {
                toast.success("با موفقیت ثبت شد.");
                this.getOrder();
            })
            .catch(err => {
                config.handleError(err)
            });
    }

    delete() {
        axios.delete(`${config.api}/admin/order?token=${config.token}&id=${this.props.params.id}`)
            .then(r => {
                toast.success("با موفقیت حذف شد");
                this.props.navigate(-1);
            })
            .catch(err => {
                config.handleError(err);

            });
    }

    expertIsActive(e) {
        const {selectExperts} = this.state;
        let isActive = false;
        selectExperts.map(se => {
            if (e.id === se) {
                isActive = true;
            }
        });
        return isActive;
    }

    edit() {
        const {id, address, time, mDate, mTime} = this.state;
        let dateTime = mDate + " " + mTime;

        let params = new URLSearchParams();
        params.append("id", id);
        params.append("address", address);
        params.append("time", time);
        params.append("dateTime", dateTime);

        axios.put(`${config.api}/admin/order/edit?token=${config.token}`, params)
            .then(r => {
                toast.success("با موفقیت ویرایش شد.");
                this.getOrder();
                this.setState({modalEdit: false});
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    render() {
        const {
            expert, experts, address, code, allExperts, user, dateTime, mDate, mTime, gadgets, options,
            payment, region, service, status, tel, time, price, description,
            modalExpert, selectExperts,
            modalEdit
        } = this.state;

        return (
            <div className="edit-order">
                <Modal title="ویرایش" display={modalEdit}
                       onCloseClick={() => this.setState({modalEdit: false})}>
                    <Field type="textarea"
                           name="address"
                           value={address}
                           row={3}
                           label="آدرس"
                           onChange={(name, value) => this.setState({[name]: value})}/>
                    <Field type="number"
                           name="time"
                           value={time}
                           style={{direction: "ltr"}}
                           maxLength={4}
                           label="زمان مورد نیاز"
                           onChange={(name, value) => this.setState({[name]: value})}/>
                    <div className="row">
                        <div className="col-6">
                            <Field type="text"
                                   name="mDate"
                                   value={mDate}
                                   style={{direction: "ltr"}}
                                   maxLength={8}
                                   label="تاریخ"
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                        </div>
                        <div className="col-6">
                            <Field type="text"
                                   name="mTime"
                                   value={mTime}
                                   style={{direction: "ltr"}}
                                   maxLength={8}
                                   label="ساعت"
                                   onChange={(name, value) => this.setState({[name]: value})}/>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <Button submit={false} icon="check" onClick={() => this.edit()}>ویرایش کردن</Button>
                        </div>
                    </div>
                </Modal>
                <Modal title="اعزام متخصص" display={modalExpert}
                       onCloseClick={() => this.setState({modalExpert: false})}>
                    <div className="modal-experts">
                        {
                            allExperts.map((e, i) =>
                                <article key={"expert" + i}
                                         className={this.expertIsActive(e) ? "active" : ""}
                                         onClick={() => {
                                             let select = selectExperts;
                                             let index = -1;
                                             select.map((s, si) => {
                                                 if (s === e.id) {
                                                     index = si;
                                                 }
                                             });

                                             if (index === -1) {
                                                 select.push(e.id)
                                             } else {
                                                 select.splice(index, 1)
                                             }

                                             this.setState({selectExperts: select});
                                         }}>
                                    <div className="row">
                                        <div className="col-auto">
                                            <div className="image"><img src={e.personalPhoto} alt=""/></div>
                                        </div>
                                        <div className="col">
                                            <div className="full-name"><span>{e.firstName}</span>&nbsp;
                                                <span>{e.lastName}</span></div>
                                            <div className="phone-number">{e.phoneNumber}</div>
                                        </div>
                                    </div>
                                </article>
                            )
                        }
                        <div className="row justify-content-center">
                            <Button submit={false}
                                    onClick={() => this.refExpert()}>اعزام کردن</Button>
                        </div>
                    </div>
                </Modal>
                <Back {...this.props}/>
                <br/>
                <div className="row">
                    <div className="col-md-4">
                        <Button submit={false} icon="edit"
                                onClick={() => this.setState({modalEdit: true})}>ویرایش</Button>
                    </div>
                </div>
                <br/>
                <h1>{code}</h1>
                {user ?
                    <div className="user">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="full-name"><span>{user.firstName}</span>&nbsp;
                                    <span>{user.lastName}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="phone-number">{user.phoneNumber}&nbsp;({user.gender})</div>
                            </div>
                        </div>
                    </div>
                    : null}

                {payment ?
                    <div className="payment">
                        <p><span>شناسه تراکنش:</span><span>{payment.transid}</span></p>
                        <p><span>شماره پیگیری:</span><span>{payment.tracking_number}</span></p>
                        <p><span>بانک:</span><span>{payment.bank}</span></p>
                        <p><span>شماره کارت:</span><span>{payment.cardnumber}</span></p>
                        <p><span>وضعیت:</span><span
                            style={{color: payment.status === "پرداخت موفق" ? "#43A047" : "#D32F2F"}}>{payment.status}</span>
                        </p>
                    </div> : null}

                <div className="price">
                    <p><span>مبلغ:</span><span>{config.priceFormatter(price)}</span></p>
                </div>
                {
                    experts ? experts.map((e, ei) =>
                        <div className="expert-info" key={"exp" + ei}>
                            <div className="title">متخصص:</div>
                            <div className="row">
                                <div className="col-auto">
                                    <div className="image"><img src={e.personalPhoto} alt=""/></div>
                                </div>
                                <div className="col">
                                    <p className="full-name"><span>{e.firstName}</span>&nbsp;
                                        <span>{e.lastName}</span></p>
                                    <p className="phone-number">{e.phoneNumber}</p>
                                </div>
                            </div>
                        </div>
                    ) : null
                }
                {expert ?
                    <div className="expert-info">
                        <div className="title">متخصص:</div>
                        <div className="row">
                            <div className="col-auto">
                                <div className="image"><img src={expert.personalPhoto} alt=""/></div>
                            </div>
                            <div className="col">
                                <p className="full-name"><span>{expert.firstName}</span>&nbsp;
                                    <span>{expert.lastName}</span></p>
                                <p className="phone-number">{expert.phoneNumber}</p>
                            </div>
                        </div>
                    </div>
                    : null}
                <div className="row justify-content-center">
                    <div className="col-md-5">
                        <Button submit={false} icon="check"
                                onClick={() => this.setState({modalExpert: true})}>اعزام
                            متخصص</Button>
                    </div>
                </div>
                <div className="info">
                    <Select
                        label="وضعیت"
                        simple
                        options={[
                            {t: "ثبت اولیه", v: "ثبت اولیه"},
                            {t: "پرداخت شده", v: "پرداخت شده"},
                            {t: "در حال اعزام", v: "در حال اعزام"},
                            {t: "در مسیر", v: "در مسیر"},
                            {t: "در محل", v: "در محل"},
                            {t: "پایان کار", v: "پایان کار"},
                            {t: "خروج", v: "خروج"},
                            {t: "کنسل شده", v: "کنسل شده"}
                        ]}
                        value={status}
                        name="status"
                        onChange={(name, value) => {
                            this.setState({[name]: value});
                            this.setStatus(value);
                        }}/>
                    {region ?
                        <p><span>محله:</span><span>{region.title}</span></p> :
                        null}
                    <p><span>آدرس:</span><span>{address}</span></p>
                    <p><span>زمان مورد نیاز:</span><span>{time}</span></p>
                    <p><span>تاریخ و ساعت:</span><span>{dateTime}</span></p>
                    <p><span>توضیحات:</span><span>{description}</span></p>
                    <p><span>تلفن اضطراری:</span><span>{tel}</span></p>

                    {
                        service ?
                            <div className="service-info">
                                <div className="row">
                                    <div className="col-auto">
                                        <div className="image"><img src={service.image} alt=""/></div>
                                    </div>
                                    <div className="col">
                                        <div className="title">{service.title}</div>
                                        <div className="price">{config.priceFormatter(service.price)}</div>
                                    </div>
                                </div>
                            </div> : null
                    }

                    <div className="options">
                        <div className="title">گزینه ها:</div>
                        {
                            options.map((o, i) =>
                                <div className="item" key={"opt" + i}>
                                    <span>{o.t}</span><span>{o.v}</span>
                                </div>
                            )
                        }
                    </div>

                    <div className="gadgets">
                        <div className="title">ابزار ها:</div>
                        {
                            gadgets.map((g, i) =>
                                <div className="item" key={"gad" + i}>{g}</div>
                            )
                        }
                    </div>
                    <br/><br/><br/><br/>

                    <div className="row">
                        <div className="col-md-5">
                            <Button submit={false} backgroundColor="#E53935"
                                    icon="trash"
                                    onDoubleClick={() => this.delete()}>حذف کردن (دوبار کلیک)</Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default gpn(EditOrder);